import ScrollView from 'devextreme-react/scroll-view';
import type { ReactNode } from 'react';
import { hasPharmacyOpsAccess, hasSalesToolsAccess } from './roles';
import { useAuthStore } from './useAuthStore';

interface Props {
  children: ReactNode;
  /** Which unreleased department tool area to gate. */
  area: 'sales' | 'pharmacy';
}

/**
 * Gates Sales / Pharmacy Operations pages for ItSysAdmin + OpsOperations (ops admin).
 * Department roles keep deep-link access; their nav entries stay hidden separately.
 */
export function RequireUnreleasedDepartmentAccess({ children, area }: Props) {
  const roles = useAuthStore((s) => s.roles);
  const allowed =
    area === 'sales' ? hasSalesToolsAccess(roles) : hasPharmacyOpsAccess(roles);

  if (!allowed) {
    return (
      <ScrollView>
        <div style={{ padding: '2rem', maxWidth: 560 }}>
          <h2>Access denied</h2>
          <p>
            {area === 'sales'
              ? 'You don\u2019t have permission to view this page. Required: ItSysAdmin, OpsOperations, or OpsSales.'
              : 'You don\u2019t have permission to view this page. Required: ItSysAdmin, OpsOperations, or OpsPharmacy.'}
          </p>
        </div>
      </ScrollView>
    );
  }

  return <>{children}</>;
}
